module.exports = __webpack_public_path__ + "img/shop_eg.6ad63027.jpg";